module.exports = __webpack_public_path__ + "img/favicon_007.00fd8ba8.png";